import { useEffect } from 'react'

type Props = {
  isReady?: boolean
  value?: string
  valueDefault?: string
  keyLocalStorage: string
  onChange?: (value: string) => void
}

export const useSimpleLocalStorage = ({
  isReady,
  value,
  valueDefault,
  keyLocalStorage,
  onChange,
}: Props) => {
  const valueLocalStorage = localStorage.getItem(keyLocalStorage)

  const valueComputed = value ?? valueLocalStorage ?? valueDefault

  useEffect(() => {
    if (valueComputed) {
      localStorage.setItem(keyLocalStorage, valueComputed)
    }
  }, [isReady, valueComputed])

  useEffect(() => {
    if (valueComputed && valueComputed !== value) {
      onChange?.(valueComputed)
    }
  }, [isReady, valueComputed, value])

  return {
    value: valueComputed,
  }
}
